exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-header-logo[data-v-5d546402]{display:inline-block;max-width:300px;height:50px;line-height:50px;box-sizing:border-box}.link-header-logo .lenovo-link[data-v-5d546402]{display:inline-block;height:50px;width:auto}.link-header-logo .custom-logo[data-v-5d546402]{max-width:300px;max-height:50px}.link-header-logo .lenovo-logo[data-v-5d546402]{width:208px;height:20px;line-height:50px;margin:15px auto}", ""]);

// exports
